/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum BarcodeOutcome {
  EXACT_MATCH = 'EXACT_MATCH',
  AMBIGUOUS = 'AMBIGUOUS',
  IDENTIFIER_NOT_IN_REFERENCE_DATA = 'IDENTIFIER_NOT_IN_REFERENCE_DATA',
  NO_MAPPING_FOR_VALID_BARCODE = 'NO_MAPPING_FOR_VALID_BARCODE',
  INVALID_CHECK_DIGIT = 'INVALID_CHECK_DIGIT',
  UNSUPPORTED_FORMAT = 'UNSUPPORTED_FORMAT',
  KNOWN_RECORD_UNMAPPABLE = 'KNOWN_RECORD_UNMAPPABLE',
}
